<layout-page-container>
  <layout-header-container title="Geschäftsvorfälle"/>

  <layout-form-container [permission]="PermissionService.Inventory_BusinessCase_Add()"
                         submitText="Geschäftsvorfall anlegen" clearText="Felder zurücksetzen"
                         [element]="name" (clear)="new.clear()" (submit)="add()" (searchValueChange)="filter($event)">
    <div class="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
      <div class="sm:col-span-4">
        <label for="businesscase-name" class="block text-sm font-medium leading-6 text-gray-900">Name</label>
        <input #name [(ngModel)]="new.name"
               type="text" name="businesscase-name" id="businesscase-name" autocomplete="businesscase-name"
               class="mt-2 block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6">
      </div>
      <div class="sm:col-span-2">
        <label for="businesscase-type" class="block text-sm font-medium leading-6 text-gray-900">Kategorie</label>
        <ng-select name="businesscase-type" id="businesscase-type"
                   [(ngModel)]="new.type"
                   [clearable]="false"
                   class="ng-select cheqme-style mt-2 block rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6">
          @for (type of types; track type) {
            <ng-option [value]="parseInt(type)">{{ BusinessCaseTypeLabels[parseInt(type)] }}</ng-option>
          }
        </ng-select>
      </div>
      <div class="sm:col-span-3">
        <label for="businesscase-value" class="block text-sm font-medium leading-6 text-gray-900">Wert</label>
        <input #name [(ngModel)]="new.value"
               type="number" name="businesscase-value" id="businesscase-value" autocomplete="businesscase-value"
               class="mt-2 block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6">
      </div>
      <div class="sm:col-span-3">
        <label for="businesscase-calculationtype" class="block text-sm font-medium leading-6 text-gray-900">Berechnungsart</label>
        <ng-select name="businesscase-type" id="businesscase-calculationtype"
                   [(ngModel)]="new.calculationType"
                   [clearable]="false"
                   class="ng-select cheqme-style mt-2 block rounded-md border-0 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6">
          @for (type of calculationTypes; track type) {
            <ng-option [value]="parseInt(type)">{{ BusinessCaseCalculationTypeLabels[parseInt(type)] }}</ng-option>
          }
        </ng-select>
      </div>
    </div>
  </layout-form-container>
  <layout-page-scrollable>
    <div class="mt-2 flow-root">
      <div class="inline-block min-w-full py-2 align-middle">
        <table class="min-w-full border-separate border-spacing-0">
          <thead>
          <tr>
            <th scope="col"
                class="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter sm:pl-6 lg:pl-8">
              Name
            </th>
            <th scope="col"
                class="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
              Geschäftsvorfall
            </th>
            <th scope="col"
                class="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
              Wert
            </th>
            <th scope="col"
                class="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
              Berechnungsart
            </th>
            <th scope="col" *ngIf="PermissionService.CheckPermission(PermissionService.Inventory_BusinessCase_Delete())"
                class="sticky top-0 z-10 border-b border-gray-300 bg-white bg-opacity-75 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 backdrop-blur backdrop-filter">
            </th>
          </tr>
          </thead>
          <tbody>
            @if (bc_full === undefined) {
              <app-loading/>
            } @else if (bc_full === null) {
              Laden fehlgeschlagen
            } @else {
              @for (b of bc; track b.id) {
                <tr>
                  <td
                    class="whitespace-nowrap border-b border-gray-200 py-2 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 lg:pl-8">
                    {{ b.name }}
                  </td>
                  <td
                    class="whitespace-nowrap border-b border-gray-200 px-3 py-2 text-sm text-gray-500">
                    {{ BusinessCaseTypeLabels[b.type] }}
                  </td>
                  <td
                    class="whitespace-nowrap border-b border-gray-200 px-3 py-2 text-sm text-gray-500">
                    {{ b.value | number: '1.0-2' }}
                  </td>
                  <td
                    class="whitespace-nowrap border-b border-gray-200 px-3 py-2 text-sm text-gray-500">
                    {{ BusinessCaseCalculationTypeLabels[b.calculationType] }}
                  </td>
                  <td *ngIf="PermissionService.CheckPermission(PermissionService.Inventory_BusinessCase_Delete())"
                      class="whitespace-nowrap border-b border-gray-200 px-3 py-2 text-sm text-gray-500">
                    <a class="text-theme-primary-700 hover:text-theme-primary-900" (click)="delete(b)">Löschen</a>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    </div>
  </layout-page-scrollable>
</layout-page-container>
